export const WAITING_REQUEST = "waitingRequest";
export const SET_SUCCESS_FEEDBACK = "setSuccessFeedback";
export const API_TIMEOUT = 3000;
export const PRUEBA_KO = "pruebaKO123";
export const RESPONSE_OK = { status: 200 };
export const RESPONSE_KO = { status: 401 };
export const IS_HINT_ENETERED = "isHintEntered";
export const IS_PASSWORD_ENTERED = "isPasswordEntered";
export const IS_PASSWORD_ENTERED_AFTER_DELAY = "isPasswordEnteredAfterDelay";
export const PASSWORD_INPUT_TIMEOUT = 800;
